export enum paymentLinkTypes {
    FETCH_LINKS_REQUEST = 'FETCH_LINKS_REQUEST',
    FETCH_LINKS_BY_ID = 'FETCH_LINKS_BY_ID',
    CREATE_LINK_REQUEST = 'CREATE_LINK_REQUEST',
    EDIT_LINK_REQUEST = 'EDIT_LINK_REQUEST',
    DELETE_LINK_REQUEST = 'DELETE_LINK_REQUEST',
    SET_LINKS = 'SET_LINKS',
    SET_LINK = 'SET_LINK',
}
